<template>
    <div class="active_table" ref="content">
      <toolbar>
        <div class="search" style="width: 100%">
          <!-- 企业选择 -->
          <div class="label">企业名称：</div>
          <Select
            v-model="search.uuid"
            style="width: 7.8em;margin-right:1em;"
            @on-change="getSiteList"
            placeholder="请选择企业"
            clearable
          >
            <Option v-for="item in companyList" :value="item.uuid" :key="item.id">{{ item.name }}</Option>
          </Select>
          <!-- 站点选择 -->
          <div class="label">选择日期：</div>
          <DatePicker type="datetime" v-model="search.date" confirm format="yyyy-MM-dd" placeholder="选择日期" style="width: 200px"></DatePicker>

          <div class="label" style="margin-left: 10px">选择时间：</div>
          <TimePicker format="HH:mm" v-model="search.time" type="timerange" placement="bottom-end" placeholder="选择时间" style="width: 168px"></TimePicker>
          <!-- <DatePicker
            type="daterange"
            placement="bottom-end"
            placeholder="选择日期"
            style="width: 200px;margin-left: 10px"
            @on-change="dateSelect($event)"
          ></DatePicker>-->
          <!-- <Select
            v-model="search.timeSegmentation"
            clearable
            style="width:100px;margin-left:10px;text-align:center;"
          >
            <Option
              v-for="item in timeSegmentationList"
              :key="item.value"
              :value="item.value"
            >{{ item.name }}</Option>
          </Select>-->
          <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
          <i-button type="default" @click="portExel" style="margin-left: 1em;">导出</i-button>
        </div>
      </toolbar>
      <div class="table">
        <i-table border :columns="table.columns" :max-height="table.maxHeight" :span-method="handleSpan" :data="table.data"></i-table>
        <!-- <Page
          :total="table.total"
          show-sizer
          :page-size="40"
          @on-change="pageCurrentChange($event)"
          @on-page-size-change="pageSizeChange($event)"
          style="text-align:right;margin-top: 1em"
        /> -->
        <Spin fix v-show="table.loading"></Spin>
      </div>
    </div>
  </template>
  
  <style lang="scss" scoped>
  .active_table {
    width: 100%;
    height: 100%;
    padding-top: 2em;
  }
  .table {
    padding: 0 1em;
    width: 100%;
    height: calc(100% - 5.5em);
    position: relative;
  }
  .content {
    width: 700px;
    img {
      width: 100%;
    }
  }
  </style>
  
  <script>
  import toolbar from "../../../p_company/components/toolBar.vue"; // 操作栏组件
  import { timeStamp } from "../../../util/common/date"; // 时间转化工具
  import { emComputed } from "../../../util/common/fontSize"; // em转化工具
  import { Resize } from "../../../util/common/resize";
  import axios from 'axios';
  import { BaseUrl } from '../../../http/config';
  
  export default {
    data() {
      return {
        // 表格
        table: {
          // 表格属性
          columns: [
            {
                title: '企业',
                key: 'companyName',
                align: 'center',
                width: 200
            },
            {
                title: '站点',
                key: 'siteName',
                width: 100,
                align: 'center'
            },
            {
                title: '站点状态',
                key: 'siteState',
                align: 'center',
                width: 100
            },
            {
                title: '告警事件',
                align: 'center',
                children: [
                    {
                        title: '设备名称',
                        align: 'center',
                        render: (h, params) => {
                          return h("div", [
                              h("span", {}, params.row.siteDeviceName)
                          ]);
                        }
                    },
                    {
                        title: '设备状态',
                        align: 'center',
                        render: (h, params) => {
                          return h("div", [
                            h("span", {}, params.row.siteDeviceState)
                          ]);
                        }
                    },
                    {
                        title: '时间',
                        align: 'center',
                            render: (h, params) => {
                            return h("div", [
                                h(
                                "span",
                                {},
                                timeStamp(params.row.startTime, "yyyy-MM-dd HH:mm")
                                )
                            ]);
                            }
                    }
                ]
                    },
                {
                    title: '运维事件',
                    align: 'center',
                    children: [
                        {
                            title: '状态',
                            align: 'center',
                            render: (h, params) => {
                            return h("div", [
                                h(
                                  "span",
                                  {},
                                  params.row.expire ? "已处理":"未处理"
                                  )
                              ]);
                            }
                        },
                        {
                            title: '时间',
                            align: 'center',
                            render: (h, params) => {
                                    return h("div", [
                                      h(
                                        "span",
                                        {},
                                        timeStamp(params.row.endTime, "yyyy-MM-dd HH:mm")
                                      )
                                    ]);
                                  }
                        }
                    ]
                }
          ],
          data: [],
          pageCurrent: 1,
          pageSize: 40,
          total: 0,
          loading: true,
          maxHeight: null
        },
        // 查询
        search: {
          date: null,
          time: null,
          uuid: null,
          startTime: new Date().getTime() - 86400000 + 1000,
          endTime: new Date().getTime()
        },
        siteList: [], // 站点枚举列表
        deviceList: [], // 设备枚举
        timeSegmentationList: [
          {
            name: "每分钟",
            value: 60
          },
          {
            name: "每十分钟",
            value: 600
          },
          {
            name: "每小时",
            value: 3600
          }
        ],
        // 企业列表
        companyList: [],
        ceshiMap: {
          
        }
      };
    },
    components: {
      toolbar
    },
    created: async function() {
      await this.getCompany(); // 获取企业列表
      this.getSiteList(); // 获取站点枚举
      this.getData();
      this.tableInit(); // 表格初始化
      window.addEventListener("resize", this.tableInit);
    },
    methods: {
      handleSpan ({ row, column, rowIndex, columnIndex }) {
        return this.ceshiMap[rowIndex + "-" + columnIndex];
      },
      getData() {
        // 获取数据
        this.table.loading = true;
        //console.log(this.search, "是")
        this.$api.Warn.getTodayData(
          {
            // pageCurrent: this.table.pageCurrent,
            // pageSize: this.table.pageSize,
            content: {
              uuid: this.search.uuid,
              startTime: this.search.startTime,
              endTime: this.search.endTime
            }
          },
          [null, "park"]
        ).then(res => {
          if (res.code == 0) {
            // 获取成功
            //console.log(res);
            let data = res.data;
            // 合并单元格 start
            for (let i=0; i<data.length; i++) {
              data[i]._index = i;
            }
            this.initData(data, "companyName");
            // end
            this.table.data = data;
            this.table.loading = false;
            this.$Message.success("加载完成");
          } else {
            this.$Message.warning(res.message);
            this.table.loading = false;
          }
        });
      },
      // 单元格初始化
      initData(data, key) {
        let someMap = {};
        data.map(res => {
          if (!someMap[res[key]]) {
            someMap[res[key]] = [];
            someMap[res[key]].push(res)
          } else {
            someMap[res[key]].push(res)
          }
        });
        
        for (let item in someMap) {
          
          someMap[item].map((res, index) => {
            let col,row;
            if (index == 0) {
              row = someMap[item].length;
              col = 1;
              // someMap[item][index]._row = someMap[item].length;
            } else {
              row = 0;
              col = 0;
              // someMap[item][index]._row = 0;
            }
            
            if (key == "companyName") {
              //console.log(res._index, col,row)
              this.ceshiMap[res._index + "-0"] = [row, col]
            } else if (key == "siteName") {
              //console.log(res._index, col,row)
              this.ceshiMap[res._index + "-1"] = [row, col]
            } else if (key == "siteState") {
              //console.log(res._index, col,row)
              this.ceshiMap[res._index + "-2"] = [row, col]
            } else if (key == "siteDeviceName") {
              //console.log(res._index, col,row)
              this.ceshiMap[res._index + "-3"] = [row, col]
            } else if (key == "siteDeviceState") {
              //console.log(res._index, col,row)
              this.ceshiMap[res._index + "-4"] = [row, col]
            }
          });
          if (key == "companyName") {
            this.initData(someMap[item], "siteName");
          }
          if (key == "siteName") {
            this.initData(someMap[item], "siteState");
          }
          if (key == "siteState") {
            this.initData(someMap[item], "siteDeviceName");
          }
          if (key == "siteDeviceName") {
            this.initData(someMap[item], "siteDeviceState");
          }
        }
      },
      // 搜索
      searchFunc() {
        if (!this.search.date) {
          this.search.date = new Date();
        }
        this.search.date = timeStamp(this.search.date, "yyyy-MM-dd");
        this.search.startTime = this.search.date + " " + (this.search.time[0] ? this.search.time[0] : "00:00:00");
        
        
        this.search.startTime = new Date(this.search.startTime).getTime();
        if (!this.search.time[1]) {
          this.search.endTime = this.search.date + " " + "00:00:00";
          this.search.endTime = new Date(this.search.endTime).getTime() + 86400000 - 1000;
        } else {
          this.search.endTime = this.search.date + " " + this.search.time[1];
          this.search.endTime = new Date(this.search.endTime).getTime();
        }
        //console.log(this.search)
        this.getData();
      },
      pageCurrentChange(num) {
        // 页码跳转
        this.table.pageCurrent = num;
        this.getData();
      },
      pageSizeChange(num) {
        // 每页数量切换
        this.table.pageSize = num;
        this.getData();
      },
      // 获取站点枚举值
      getSiteList() {
        this.$api.Enum.getSiteEnum({ content: { uuid: this.search.uuid } }, [
          null,
          "park"
        ]).then(res => {
          if (res.code == 0) {
            this.siteList = res.data;
          } else {
            this.$Notice.warning({
              title: "获取站点枚举失败",
              desc: res.message || "请联系管理员"
            });
          }
        });
      },
      // 获取设备
      selectDevice(msg) {
        let siteList = this.siteList;
        let site = siteList.filter(res => {
          return res.id == msg;
        });
        this.$api.Enum.getDeviceEnum({ content: { mn: site[0].mn } }, [
          "uuids",
          "park"
        ]).then(res => {
          if (res.code == 0) {
            this.deviceList = res.data;
          } else {
            this.$Notice.warning({
              title: "获取端口对应设备失败",
              desc: res.message || "请联系管理员"
            });
          }
        });
      },
      // 选择时间
      dateSelect(date) {
        this.search.startDate = new Date(date[0]).setHours("0");
        this.search.endDate = new Date(date[1]).setHours("24");
      },
      // 表格高度计算
      tableInit() {
        this.$nextTick(() => {
          if (this.$route.path != "/ahome/warnEvent") {
            window.removeEventListener("resize", this.tableInit);
            return false;
          }
          let tableH = this.$refs.content.clientHeight;
          let headerH = emComputed(9.5); // 操作栏5.5em转换px， 2em的上下边距分页组件
          this.table.maxHeight = tableH - headerH - 32; // 32px的分页组件高度
        });
      },
      // 获取企业列表
      getCompany() {
        return new Promise((resolve, reject) => {
          this.$api.A_Company.getCompanyHomeList(null, ["uuids", "park"]).then(
            res => {
              if (res.code == 0) {
                let data = res.data;
                this.companyList = data;
                resolve();
              } else {
                this.$Notice.warning({
                  title: "获取企业列表失败",
                  desc: res.message || "请联系管理员"
                });
              }
            }
          );
        });
      },
      /****
       * 到处exl
      */
      portExel() {
        let url = BaseUrl + "/api/park/report/exp?";
        url += "content=" + encodeURI(JSON.stringify({
          uuid: this.search.uuid,
          startTime: this.search.startTime,
          endTime: this.search.endTime
        }))
        axios({
          methods: 'get',
          url: url,
          withCredentials: true,
          responseType: 'blob'
        }).then(res => {
          //console.log(res)
          let a = document.createElement("a");
          a.download = "ribao.csv";
          let blob = new Blob([res.data])
            
          a.href = window.URL.createObjectURL(blob);
          a.click();
        })

        //
        // this.$api.Warn.portExp({
        //   content: {
        //     uuid: this.search.uuid,
        //     startTime: this.search.startTime,
        //     endTime: this.search.endTime
        //   }
        // }, [null, "park"]).then(
        //   res => {
            
            
            
        //     return
        //   }
        // ).catch(err => {
        //   console.log(err)
        // })
      }
    }
  };
  </script>